import Vue from 'vue'
import SvgIcon from 'src/components/SvgIcon'// svg组件

// register globally
Vue.component('svg-icon', SvgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /\.svg$/)
const iconMap = requireAll(req)


// WEBPACK FOOTER //
// ./src/icons/index.js